import React from "react";
import CommHeatmap from "./CommHeatmap";

const CHANNELS = [
  { key: "email", label: "Emails", cls: "text-blue-700 bg-blue-50/50 border-blue-200", strokeCls: "stroke-blue-500" },
  { key: "sms", label: "SMS", cls: "text-slate-700 bg-slate-50/50 border-slate-200", strokeCls: "stroke-slate-500" },
  { key: "whatsapp", label: "WhatsApp", cls: "text-green-700 bg-green-50/50 border-green-200", strokeCls: "stroke-green-500" },
];

/** SVG sparkline compacto (60x18). Recebe vetor de números e cor via strokeCls tailwind. */
const Sparkline = ({ values, strokeCls, testid }) => {
  const w = 72, h = 22, pad = 2;
  const max = Math.max(1, ...values);
  const step = values.length > 1 ? (w - pad * 2) / (values.length - 1) : 0;
  const pts = values.map((v, i) => {
    const x = pad + i * step;
    const y = h - pad - (v / max) * (h - pad * 2);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(" ");
  const lastX = pad + (values.length - 1) * step;
  const lastY = h - pad - (values[values.length - 1] / max) * (h - pad * 2);
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} data-testid={testid} className="overflow-visible">
      <polyline points={pts} fill="none" strokeWidth="1.5" className={strokeCls} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={lastX} cy={lastY} r="2" className={`${strokeCls.replace("stroke", "fill")}`} />
    </svg>
  );
};

export const CommKpiCard = ({ commKpi, onViewHistory, onHeatmapCellClick }) => {
  if (!commKpi) return null;
  const daily = commKpi.daily_7d || [];
  const seriesTotal = daily.map((d) => d.total || 0);
  return (
    <div className="mb-8 p-5 border border-slate-200 rounded-xl bg-gradient-to-br from-white to-slate-50" data-testid="comm-kpi-card">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-slate-500">Volume operacional</div>
          <div className="font-display font-bold text-lg text-[#0B2B62]">Envios das últimas 24h</div>
        </div>
        <button onClick={onViewHistory} data-testid="comm-kpi-view-history"
          className="text-xs px-3 py-1.5 border border-slate-200 rounded-md hover:bg-slate-50 text-slate-600">
          Ver histórico
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <div className="p-3 rounded-lg border border-slate-200 bg-white flex flex-col gap-1.5">
          <div className="text-[10px] uppercase tracking-widest text-slate-500">Total 24h</div>
          <div className="font-display font-bold text-2xl text-[#0B2B62]" data-testid="kpi-total-24h">{commKpi.last_24h.total}</div>
          <Sparkline values={seriesTotal} strokeCls="stroke-[#0B2B62]" testid="sparkline-total" />
          <div className="text-[10px] text-slate-400">7d total: {commKpi.last_7d.total}</div>
        </div>
        {CHANNELS.map((c) => {
          const series = daily.map((d) => d[c.key] || 0);
          const label24 = c.key === "whatsapp" ? commKpi.last_24h.whatsapp_outbound + commKpi.last_24h.whatsapp_inbound : commKpi.last_24h[c.key];
          const label7d = commKpi.last_7d[c.key];
          const testid24 = `kpi-${c.key === "whatsapp" ? "wa" : c.key}-24h`;
          return (
            <div key={c.key} className={`p-3 rounded-lg border flex flex-col gap-1.5 ${c.cls}`}>
              <div className="text-[10px] uppercase tracking-widest opacity-80">{c.label}</div>
              <div className="font-display font-bold text-2xl" data-testid={testid24}>{label24}</div>
              <Sparkline values={series} strokeCls={c.strokeCls} testid={`sparkline-${c.key}`} />
              <div className="text-[10px] opacity-70">7d: {label7d}</div>
            </div>
          );
        })}
        <div className="p-3 rounded-lg border border-emerald-200 bg-emerald-50/50 flex flex-col gap-1.5">
          <div className="text-[10px] uppercase tracking-widest text-emerald-700">WA inbound</div>
          <div className="font-display font-bold text-2xl text-emerald-900" data-testid="kpi-wa-in-24h">{commKpi.last_24h.whatsapp_inbound}</div>
          <div className="text-[10px] text-emerald-700 mt-auto">Respostas de família/clínica</div>
        </div>
      </div>
      <CommHeatmap matrix={commKpi.heatmap_30d} onCellClick={onHeatmapCellClick} />
    </div>
  );
};

export default CommKpiCard;
